import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

const SetCloseModalContext = createContext<VoidFunction>(() => null);

export const ModalProvider = ({
  setClose,
  children,
}: PropsWithChildren<{
  setClose: VoidFunction;
}>) => {
  return <SetCloseModalContext.Provider value={setClose}>{children}</SetCloseModalContext.Provider>;
};

export const useCloseModal = () => useContext(SetCloseModalContext);
